import { render, staticRenderFns } from "./PublicDDSReport.vue?vue&type=template&id=8ac8e878&scoped=true"
import script from "./PublicDDSReport.vue?vue&type=script&lang=js"
export * from "./PublicDDSReport.vue?vue&type=script&lang=js"
import style0 from "./PublicDDSReport.vue?vue&type=style&index=0&id=8ac8e878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8e878",
  null
  
)

export default component.exports